module.exports = __webpack_public_path__ + "static/media/clocards-signin.4285ae2f.png";